import { render, staticRenderFns } from "./Pic.vue?vue&type=template&id=66602f08&scoped=true&"
import script from "./Pic.vue?vue&type=script&lang=js&"
export * from "./Pic.vue?vue&type=script&lang=js&"
import style0 from "./Pic.vue?vue&type=style&index=0&id=66602f08&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66602f08",
  null
  
)

export default component.exports